





































































import { Component, Vue } from 'vue-property-decorator';
import { State, Action } from 'vuex-class';

import { Organization } from '@/common/Organizations';
import { CleanID } from '@/utils/Utils';

import Welcome from '@/components/Global/Welcome.vue';
import TextField from '@/components/Form/TextField.vue';
import SwitchField from '@/components/Form/SwitchField.vue';

import { required, requiredIf } from 'vuelidate/lib/validators';

@Component({
	name: 'NewOrganization',
	components: {
		Welcome,
		TextField,
		SwitchField,
	},
	validations: {
		fields: {
			org_name: {
				required,
			},
			brokerageId: {
				requiredIf: requiredIf(vm => vm.is_agency),
			},
		},
	},
})
export default class NewOrg extends Vue {
	@Action('createOrganization', { namespace: 'Organizations' }) private createOrganization: (
		fields: Organization,
	) => string;

	private isInvalid: boolean = false;
	private success: boolean = false;
	private error: boolean = false;
	private fields: Organization = {
		org_name: '',
		is_agency: false,
		brokerageId: '',
		address: {
			address_line_1: '',
			address_line_2: '',
			city: '',
			state: '',
			zipcode: '',
		},
		phone_number: '',
	};

	private async createOrg() {
		this.isInvalid = false;
		this.error = false;
		this.success = false;
		this.$v.$touch();

		if (this.$v.$invalid) {
			this.isInvalid = true;
			return;
		}

		if (this.fields.brokerageId !== '') {
			this.fields.brokerageId = CleanID(this.fields.brokerageId);
		}

		try {
			const newOrgId: string = await this.createOrganization(this.fields);
			this.$router.push({
				name: 'stafforganization',
				params: {
					org_id: newOrgId,
				},
			});

			this.success = true;
		} catch (e) {
			this.error = true;
		}
	}
}
